import { render, staticRenderFns } from "./StockInventory.vue?vue&type=template&id=4d491eb3&scoped=true"
import script from "./StockInventory.vue?vue&type=script&lang=js"
export * from "./StockInventory.vue?vue&type=script&lang=js"
import style0 from "./StockInventory.vue?vue&type=style&index=0&id=4d491eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d491eb3",
  null
  
)

export default component.exports